// Generated by purs version 0.15.4
import * as Halogen_HTML_Core from "../Halogen.HTML.Core/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
import * as PartyCarlo_Components_HTML_Utils from "../PartyCarlo.Components.HTML.Utils/index.js";
import * as PartyCarlo_Data_Display from "../PartyCarlo.Data.Display/index.js";
import * as PartyCarlo_Data_Result from "../PartyCarlo.Data.Result/index.js";
var display = /* #__PURE__ */ PartyCarlo_Data_Display.display(PartyCarlo_Data_Display.displayInt);
var displayRange = function (v) {
    return display(v.value0) + (" - " + display(v.value1));
};
var resultCircle = function (result) {
    return function (v) {
        if (v instanceof PartyCarlo_Data_Result.P90) {
            return Halogen_HTML_Elements.div([ PartyCarlo_Components_HTML_Utils.css("result-circle"), Halogen_HTML_Properties.id("p90") ])([ Halogen_HTML_Elements.span_([ Halogen_HTML_Core.text(displayRange(result.p90)) ]) ]);
        };
        if (v instanceof PartyCarlo_Data_Result.P95) {
            return Halogen_HTML_Elements.div([ PartyCarlo_Components_HTML_Utils.css("result-circle"), Halogen_HTML_Properties.id("p95") ])([ Halogen_HTML_Elements.span_([ Halogen_HTML_Core.text(displayRange(result.p95)) ]) ]);
        };
        if (v instanceof PartyCarlo_Data_Result.P99) {
            return Halogen_HTML_Elements.div([ PartyCarlo_Components_HTML_Utils.css("result-circle"), Halogen_HTML_Properties.id("p99") ])([ Halogen_HTML_Elements.span_([ Halogen_HTML_Core.text(displayRange(result.p99)) ]) ]);
        };
        if (v instanceof PartyCarlo_Data_Result.P999) {
            return Halogen_HTML_Elements.div([ PartyCarlo_Components_HTML_Utils.css("result-circle"), Halogen_HTML_Properties.id("p999") ])([ Halogen_HTML_Elements.span_([ Halogen_HTML_Core.text(displayRange(result.p999)) ]) ]);
        };
        throw new Error("Failed pattern match at PartyCarlo.Components.HTML.ResultCircle (line 15, column 23 - line 19, column 109): " + [ v.constructor.name ]);
    };
};
export {
    resultCircle,
    displayRange
};
